import React from "react";
import "./protfolio.css";
import IMG1 from "../../assets/portfolio1.jpg";
import IMG2 from "../../assets/portfolio2.png";
import IMG3 from "../../assets/portfolio3.png";
import IMG4 from "../../assets/portfolio4.jpg";
import IMG5 from "../../assets/portfolio5.png";
import IMG6 from "../../assets/portfolio6.jpg";

const data = [
  {
    id: 1,
    image: IMG1,
    title: "Crypto Currency API & Financial Visualization",
    github: "https://github.com",
    demo: "https://amitcryptobase.web.app/",
  },
  {
    id: 2,
    image: IMG2,
    title: "Netflix API - Movies and Series Shows",
    github: "https://github.com",
    demo: "https://netflix-react-amit.web.app/",
  },
  {
    id: 3,
    image: IMG3,
    title: "hooBank - Modern Bank App Visualization",
    github: "https://github.com",
    demo: "https://dribbble.com/shots/16955822-Maintaining-tasks-and-UI-kit-tracking-progress",
  },
  {
    id: 4,
    image: IMG4,
    title: "Eclipse - Figma dashboard UI kit for data design web apps",
    github: "https://github.com",
    demo: "https://dribbble.com/shots/18254786-Eclipse-Figma-dashboard-UI-kit-for-data-design-web-apps",
  },
  {
    id: 5,
    image: IMG5,
    title: "Eclipse - Figma dashboard UI kit for data design web apps",
    github: "https://github.com",
    demo: "https://dribbble.com/shots/18254797-Eclipse-Figma-dashboard-UI-kit-for-data-design-web-apps",
  },
  {
    id: 6,
    image: IMG6,
    title: "Eclipse - Figma dashboard UI kit for data design web apps",
    github: "https://github.com",
    demo: "https://dribbble.com/shots/18202707-Eclipse-Figma-dashboard-UI-kit-for-data-design-web-apps",
  },
];

const Protfolio = () => {
  return (
    <section id="protfolio">
      <h5>My Recent Work</h5>
      <h2>Portfolio</h2>

      <div className="container portfolio__container">
        {data.map(({ id, image, title, github, demo }) => {
          return (
            <article key={id} className="portfolio__item">
              <div className="portfolio__item-image">
                <img src={image} alt={title} />
              </div>
              <h3>{title}</h3>
              <div className="portfolio__item-cta">
                <a href={github} className="btn" target="_blank">
                  Github
                </a>
                <a href={demo} className="btn btn-primary" target="_blank">
                  Live Demo
                </a>
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
};

export default Protfolio;
